import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import withData from '@bd/bdcore-data';
import PageHelmet from '@bd/bdcore-pagehelmet';

import BuilderAreas from '../../components/BuilderAreas';

import Header from '../../components/Header';
import Footer from '../../components/Footer';
import FilterBar from '../FilterBar';
import InsideFyhHeader from '../../components/InsideFyhHeader';
import CtaBanner from '../../components/CtaBanner';
import TestimonialBanner from '../../components/TestimonialBanner';
import AreaSection from '../../components/AreaSection';
import MenuProduct from '../../components/MenuProduct';
import PlansResults from './PlansResults';
import PlanCard from './PlanCard';

const sortOptions = [
  { title: 'Name', field: 'name' },
  { title: 'Stories', field: 'stories' },
  { title: 'Sqft', field: 'import.data.plan.DescrSqf' },
];

class CardsList extends React.Component {
  constructor(props) {
    super(props);

    const increment = 12;
    this.state = {
      increment,
      limit: increment,
      mainDropdown: false,
      sort: sortOptions[0],
    };

    this.toggleDropdown = this.toggleDropdown.bind(this);
    this.addWrapperRef = this.addWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.closeDropdown = this.closeDropdown.bind(this);
    this.showMore = this.showMore.bind(this);
    this.setSort = this.setSort.bind(this);
  }

  componentDidMount() {
    document.addEventListener('mouseup', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mouseup', this.handleClickOutside);
  }

  setSort(sort) {
    let dir = 'asc';
    if (sort.title === this.state.sort.title) {
      dir = this.state.sort.dir === 'desc' ? 'asc' : 'desc';
    }
    this.setState({
      sort: { ...sort, dir },
    });
  }

  toggleDropdown(e) {
    e.preventDefault();

    this.setState({
      mainDropdown: !this.state.mainDropdown,
    });
  }

  closeDropdown() {
    this.setState({
      mainDropdown: false,
    });
  }

  addWrapperRef(node) {
    if (!this.wrapperRefs) {
      this.wrapperRefs = [];
    }
    this.wrapperRefs.push(node);
  }

  handleClickOutside(event) {
    if (this.wrapperRefs && !this.wrapperRefs.find(ref => ref && ref.contains(event.target))) {
      this.closeDropdown();
    }
  }

  showMore() {
    this.setState({
      limit: this.state.limit + this.state.increment,
    });
  }

  render() {
    const { builder, plans, metro, submetro, page } = this.props;
    const { limit, sort } = this.state;

    let areaName = 'All';
    if (submetro.name) {
      areaName = `${submetro.name}, ${submetro.state}`;
    } else if (metro.name) {
      areaName = `${metro.name}, ${metro.state}`;
    }

    const h2 = submetro.name ? metro.name : undefined;
    const featuredPlans = (plans || []).filter(plan => get(metro, 'featured_floor_plans', []).includes(plan._id));

    return (
      <div>
        <InsideFyhHeader
          h1={builder.name}
          h1Span="Floor Plans"
          h2={h2}
          background={get(page, 'page_image.contentUrl')}
        />
        <PageHelmet custom title="Available Floor Plans | 70 West Builders" />
        <Header />
        <MenuProduct />
        <div className="plan-list-wrapper" style={{ zIndex: 0 }}>
          {
            featuredPlans.length > 0 &&
            <div className="featured-plans-wrapper">
              <div className="container">
                <h3>Featured Plans for {areaName}</h3>
                <div className="row HomeCardsList Vertical">
                  {
                    featuredPlans.map(plan => (
                      <PlanCard plan={plan} key={plan._id} />
                    ))
                  }
                </div>
              </div>
            </div>
          }
          <FilterBar
            name="Floor Plans"
            setSortBy={this.setSort}
            itemCount={plans.length}
            showingCount={limit > plans.length ? plans.length : limit}
            sortOptions={sortOptions}
            type="plans"
            filterOptions={[
              {
                type: 'MultiSelect',
                filter: 'Beds',
                title: 'Beds',
                placeholder: 'All Beds',
              },
              {
                type: 'MultiSelect',
                filter: 'Baths',
                title: 'Baths',
                placeholder: 'All Baths',
              },
              {
                type: 'MultiSelect',
                filter: 'Community',
                title: 'Community',
                placeholder: 'All Communities',
              },
              // {
              //   type: 'MultiSelect',
              //   filter: 'MoveInDate',
              //   title: 'Move-In Date',
              //   placeholder: 'All Cities',
              // },
            ]}
          />
          <div className="clearfix" />
          <PlansResults sort={sort} limit={limit} areaName={areaName} showMore={this.showMore} />
        </div>
        <div id="area-info" />
        <BuilderAreas />
        <CtaBanner />
        <AreaSection />
        <TestimonialBanner />
        <Footer />
      </div>
    );
  }
}

CardsList.propTypes = {
  plans: PropTypes.arrayOf(PropTypes.object).isRequired,
  metro: PropTypes.object,
  submetro: PropTypes.object,
  builder: PropTypes.object,
  page: PropTypes.object,
};

CardsList.defaultProps = {
  metro: {},
  submetro: {},
  builder: {},
  page: undefined,
};

export default withData({
  plans: true,
  metro: true,
  submetro: true,
  builder: true,
  page: 'available_floor_plans',
}, {
  required: {
    plans: true,
  },
})(CardsList);



// WEBPACK FOOTER //
// ./src/pages/Plans/CardsList.js